import { render, staticRenderFns } from "./StructuresNotListed.vue?vue&type=template&id=605be278&"
import script from "./StructuresNotListed.vue?vue&type=script&lang=js&"
export * from "./StructuresNotListed.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports